import { BILLING_PATH } from '~constants/billing/billingPaths';

export const isBillingPath = (pathname: string): boolean =>
	pathname === BILLING_PATH || pathname.startsWith(`${BILLING_PATH}/`);
